import { render, staticRenderFns } from "./EkycWaiting.vue?vue&type=template&id=8d468c28&"
import script from "./EkycWaiting.vue?vue&type=script&lang=js&"
export * from "./EkycWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports